import React from 'react';
import { createUseStyles } from 'react-jss';
import { AddressCard } from './address-card';

function AddressImcompleteModalBody({
  placeDetails,
  baseLocation,
  config,
  onCardClick,
}) {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <AddressCard
        placeDetails={placeDetails}
        baseLocation={baseLocation}
        config={config}
        onClick={onCardClick}
      />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid white',
  },
});

export { AddressImcompleteModalBody };
